__turbopack_context__.v({
  "colourFilterColourSpot": "LmKEnW_colourFilterColourSpot",
  "colourFilterDropdownContents": "LmKEnW_colourFilterDropdownContents",
  "colourFilterDropdownOptionContainer": "LmKEnW_colourFilterDropdownOptionContainer",
  "colourFilterDropdownOptionLabel": "LmKEnW_colourFilterDropdownOptionLabel",
  "colourFilterOptionLabelContainer": "LmKEnW_colourFilterOptionLabelContainer",
  "greyBorder": "LmKEnW_greyBorder",
});
